import React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { Checkbox, Button, Select } from 'antd-v4'
import { IBaseLoyaltyTier } from '@getgreenline/homi-shared'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore/index'
import { WarningFilled } from '@ant-design/icons'
import { COLORS } from '../../../constants/Colors'
import { filterOptionV4 } from '../../../utilities/helpers'

import './index.scss'
import { DeleteLoyaltySteps } from './DeleteLoyaltyModal'

interface Props {
  loyaltyTier: IBaseLoyaltyTier
  setCurrentStep: (step: DeleteLoyaltySteps) => void
  newLoyaltyTierId: number | undefined
  setNewLoyaltyTierId: (id: number | undefined) => void
  transferCustomers: boolean
  setTransferCustomers: (bool: boolean) => void
}

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

export const DeleteModalTransferScreen: React.FC<Props & InjectedProps> = inject(
  'currentCompanyStore',
)(
  observer(
    ({
      loyaltyTier,
      currentCompanyStore,
      setCurrentStep,
      newLoyaltyTierId,
      setNewLoyaltyTierId,
      transferCustomers,
      setTransferCustomers,
    }) => {
      const loyaltyName = `'${loyaltyTier.name}'`

      const renderProceedButton = () => {
        if (transferCustomers && newLoyaltyTierId) {
          return (
            <Button
              className='opacity-on-hover'
              type='primary'
              style={{
                backgroundColor: COLORS.red400,
                borderColor: COLORS.red400,
                width: 150,
                fontSize: 17,
              }}
              onClick={() => setCurrentStep(DeleteLoyaltySteps.CONFIRMATION)}
            >
              Delete
            </Button>
          )
        }

        return (
          <Button
            className='opacity-on-hover'
            type='primary'
            style={{
              backgroundColor: COLORS.amber,
              borderColor: COLORS.amber,
              width: 200,
              fontSize: 17,
            }}
            onClick={() => setCurrentStep(DeleteLoyaltySteps.CONFIRMATION)}
          >
            Proceed Anyway
          </Button>
        )
      }

      const renderLoyaltyDropdown = () => {
        return (
          <div>
            <Select<number>
              showSearch
              defaultOpen
              className='mt-4'
              size='middle'
              dropdownMatchSelectWidth={false}
              value={newLoyaltyTierId}
              allowClear
              onChange={(loyaltyTierId) => {
                setNewLoyaltyTierId(loyaltyTierId)
              }}
              filterOption={filterOptionV4}
              style={{
                width: '100%',
              }}
              placeholder='Select...'
            >
              {currentCompanyStore?.loyaltyTiers
                ?.filter((loyalty) => loyalty.id !== loyaltyTier.id)
                .map((loyalty) => (
                  <Select.Option key={`${loyalty.id}-${loyalty.name}`} value={loyalty.id}>
                    {loyalty.name}
                  </Select.Option>
                ))}
            </Select>
          </div>
        )
      }

      return (
        <div>
          <div className='d-flex align-items-center px-2'>
            <WarningFilled style={{ fontSize: 90, marginTop: 10 }} />

            <div className='pl-4'>
              <strong
                style={{
                  fontSize: 17,
                }}
              >
                You are about to delete the {loyaltyName} loyalty tier
              </strong>

              <div>
                <Checkbox
                  className='mt-4'
                  onChange={(e) => {
                    setTransferCustomers(e.target.checked)
                    if (!e.target.checked) {
                      setNewLoyaltyTierId(undefined)
                    }
                  }}
                  checked={transferCustomers}
                >
                  <strong>Transfer the list and then delete {loyaltyName}</strong>
                </Checkbox>
              </div>

              {transferCustomers && renderLoyaltyDropdown()}
            </div>
          </div>

          <div className='d-flex justify-content-center mt-4 opacity-on-hover'>
            {renderProceedButton()}
          </div>
        </div>
      )
    },
  ),
)
